<template>
  <div id="app">
    <router-view />
    <!-- 访客聊天页面隐藏 ChatWidget，避免与全页面聊天冲突 -->
    <ChatWidget v-if="!isVisitorChatPage" :channelCode="currentChannelCode" />
    <Toast />
    <ConfirmDialog />
  </div>
</template>

<script>
import ChatWidget from './components/ChatWidget.vue'
import Toast from './components/Toast.vue'
import ConfirmDialog from './components/ConfirmDialog.vue'

export default {
  name: 'App',
  components: { ChatWidget, Toast, ConfirmDialog },
  computed: {
    isVisitorChatPage() {
      // 同时检查路由路径和实际 URL，确保可靠检测
      const routePath = this.$route.path || ''
      const urlPath = window.location.pathname || ''
      return routePath.startsWith('/chat/c/') || urlPath.startsWith('/chat/c/')
    },
    currentChannelCode() {
      // 如果 URL 中有渠道码（如 /chat/c/u2_92094f），使用该渠道
      const match = this.$route.path.match(/\/chat\/c\/([^/?]+)/)
      if (match) return match[1]
      return 'platform'
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background-color: #f0f4ff;
  color: #1a1a2e;
  -webkit-font-smoothing: antialiased;
}

a {
  text-decoration: none;
  color: inherit;
}

ul, ol {
  list-style: none;
}

input, button, textarea, select {
  font-family: inherit;
  outline: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.btn-primary {
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-primary:hover {
  background: #1d4ed8;
}

.btn-outline {
  background: transparent;
  color: #2563eb;
  border: 2px solid #2563eb;
  border-radius: 8px;
  padding: 10px 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-outline:hover {
  background: #2563eb;
  color: #fff;
}

.card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.section-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
}

.text-blue {
  color: #2563eb;
}

.text-center {
  text-align: center;
}
</style>
